import { useTranslation } from "react-i18next";

export function ErrorElement() {
  const { t } = useTranslation();

  return (
    <div className="flex h-full flex-col items-center justify-center">
      <h1 className="text-2xl font-bold">{t("errors.oops")}</h1>
      <p>{t("errors.unexpected")}</p>
    </div>
  );
}
